import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './Subject.module.css'

function Subject({ messages, requestNumber, subject }) {
  const { t } = useTranslation()

  return (
    <div className={styles.subjectWrapper}>
      <Text unread className={styles.subject}>
        {subject}
      </Text>
      {Number.isFinite(requestNumber) ? (
        <Text unread className={styles.subject}>
          {t('Email.ProfileRawServiceRequestNumberKey', {
            number: requestNumber,
          })}
        </Text>
      ) : null}
      <Text isSecondary className={styles.text}>
        {t('Email.ProfileRawCountTitleKey', { count: messages.length })}
      </Text>
    </div>
  )
}

export default Subject
